export const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const CBS_DATA_API = `${API_URL}/newcif-newaccount/get-customer-info-by-cif`
